import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import updateImageListSrc from '@utils/update-image-list-src';

interface CarnivalPCPageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    carnivalDetail?: any;
    handleImageClick: (item: any) => void;
}

@inject('app', 'site', 'user')
@observer
class CarnivalPCPage extends BasePage<CarnivalPCPageProps> {
    componentDidMount() {
        super.componentDidMount();
    }

    // 点击图片跳转（配置了 pcUrl 时）
    render() {
        const { carnivalDetail, handleImageClick } = this.props;
        // 按接口返回顺序展示图片列表
        const images = carnivalDetail?.images || [];

        return (
            <div className={styles.wrapper}>
                {images.map((item: any) => (
                    <img
                        key={item.id}
                        src={updateImageListSrc(item.image, 16)}
                        alt=""
                        className={`${styles.image} ${item.pcUrl ? styles.clickable : ''}`}
                        onClick={() => handleImageClick(item)}
                    />
                ))}
            </div>
        );
    }
}

export default withRouter(CarnivalPCPage);
